module.exports = __webpack_public_path__ + "img/door-open.ca748c12.svg";